// Module
var code = `<ngx-wizard-view class="license-payment-wizard-view"></ngx-wizard-view>`;
// Exports
export default code;